
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ces-2026",
      function () {
        return require("private-next-pages/ces-2026/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ces-2026"])
      });
    }
  